const routeMailing = () => '/mailing';

export default routeMailing;